var map = {
	"./bg-exclusive.webp": 1343,
	"./border-bg-sm.png": 1344,
	"./border-bg-xm.png": 1345,
	"./border-bg.png": 1346,
	"./btn-active.png": 1347,
	"./casino-hover.webp": 1348,
	"./cny-flower-1.webp": 1349,
	"./cny-flower-2.webp": 1350,
	"./cny-mobile-bg.webp": 1351,
	"./content-deco-1.webp": 1352,
	"./content-deco-2.webp": 1353,
	"./content-deco-3.webp": 1354,
	"./content-deco-4.webp": 1355,
	"./content-deco-5.webp": 1356,
	"./deposit-icon.webp": 1357,
	"./event-border-hover.webp": 1358,
	"./games-hover.webp": 1359,
	"./home-icon-active.webp": 1360,
	"./home-icon.webp": 1361,
	"./live-icon-active.webp": 1362,
	"./live-icon.webp": 1363,
	"./lottery-hover.webp": 1364,
	"./master-bg.png": 1365,
	"./me-icon-active.webp": 1366,
	"./me-icon.webp": 1367,
	"./p2p-hover.webp": 1368,
	"./platform.webp": 1369,
	"./product-overview-bg.webp": 1370,
	"./promos-icon-active.webp": 1371,
	"./promos-icon.webp": 1372,
	"./slots-hover.webp": 1373,
	"./sponsor-icon-active.webp": 1374,
	"./sponsor-icon.webp": 1375,
	"./sports-hover.webp": 1376,
	"./title-deco-bg.webp": 1377,
	"./title-deco-left.webp": 1378,
	"./title-deco-right.webp": 1379,
	"./vip-icon-active.webp": 1380,
	"./vip-icon.webp": 1381,
	"./withdraw-icon.webp": 1382,
	"./wwr-bg.webp": 1383,
	"./wwr-img.webp": 1384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 150;